<script setup>
import { computed } from 'vue';

const props = defineProps({
  name: { type: String, default: '' },
  src: { type: String, default: null },
  /** sm 32, md 44, lg 72, xl 96 */
  size: { type: String, default: 'md' },
  /** ink, peach, orange, sand */
  tone: { type: String, default: 'ink' },
  /** circle or square (rounded square, as in the profile tile) */
  shape: { type: String, default: 'circle' },
});
const initials = computed(() =>
  props.name.split(' ').filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('') || 'P',
);
</script>

<template>
  <span class="pd-avatar" :class="[`pd-avatar--${size}`, `pd-avatar--${tone}`, `pd-avatar--${shape}`]">
    <img v-if="src" :src="src" :alt="name" />
    <span v-else aria-hidden="true">{{ initials }}</span>
    <span v-if="!src" class="pd-sr">{{ name }}</span>
  </span>
</template>

<style scoped>
.pd-avatar {
  --d: 44px;
  display: inline-grid;
  place-items: center;
  flex: none;
  width: var(--d);
  height: var(--d);
  overflow: hidden;
  font-weight: 800;
  font-size: calc(var(--d) * 0.4);
  letter-spacing: -0.03em;
}
.pd-avatar img { width: 100%; height: 100%; object-fit: cover; }
.pd-avatar--sm { --d: 32px; }
.pd-avatar--lg { --d: 72px; }
.pd-avatar--xl { --d: 96px; }
.pd-avatar--circle { border-radius: 50%; }
.pd-avatar--square { border-radius: 30%; }
.pd-avatar--ink { background: var(--pd-ink); color: var(--pd-white); }
.pd-avatar--peach { background: var(--pd-peach); color: var(--pd-ink); }
.pd-avatar--orange { background: var(--pd-orange); color: var(--pd-on-orange); }
.pd-avatar--sand { background: var(--pd-sand); color: var(--pd-ink); }
</style>
